import DcReporter from './logger';

/**
 * 当登录后同时上报登录授权信息
 * @param thirdPartyAuthStore
 * @param isPc
 * @return {{wechat_uid: undefined, passport_uid: undefined, qq_uid: undefined}}
 * @deprecated
 */
function getTrackerAuthInfo(thirdPartyAuthStore, isPc) {
  /*if (isPc) {
    return {};
  }
  // noinspection JSUnresolvedVariable
  const thirdUid = thirdPartyAuthStore.data ? thirdPartyAuthStore.data.uid_encode : undefined;
  // noinspection JSUnresolvedVariable,SpellCheckingInspection
  const thirdPartyAuthStoreUa = thirdPartyAuthStore.ua;
  // noinspection SpellCheckingInspection

  return {
    qq_uid: thirdPartyAuthStoreUa === 'qq' ? thirdUid : undefined,
    wechat_uid: thirdPartyAuthStoreUa === 'wechat' ? thirdUid : undefined,
    /!* 春丽坚持使用 passport_uid, 个人建议过使用 *!/
    passport_uid: thirdPartyAuthStoreUa === 'daily' ? thirdUid : undefined
  };*/
}

/**
 *
 * @param config
 * @param thirdPartyAuthStore
 * @param isPc
 * @param debug
 * @return {{ev_d: any}|{stReportSdk: *, getDiffRouteTime: Function, report: report}}
 */
export default function getReport(config, thirdPartyAuthStore, isPc, debug) {
  const createCommonAttributes = config.createCommonAttributes;
  DcReporter.createCustomConfig = createCommonAttributes ? createCommonAttributes : () => ({});
  delete config.createCommonAttributes;
  const stReportSdk = DcReporter.getInstance(config, debug /* 是否开日志上报的 logger，默认是生产环境不开，平时开；想要关可以直接设为false */);

  /**
   * @type function
   * 计算上一次路由时间,
   * 对应买点中的: ev_d.td_pl(秒)
   */
  const getDiffRouteTime = stReportSdk.getDiffRouteTime.bind(stReportSdk);

  const report = ({ accountId, eventId, eventDesc, eventBody }) => {
    if (eventId === 'loadpageend') {
      throw new Error('禁止手动上报 load_page 事件, 模板 src/tracker/track-page-load.js 默认已调用 stReportSdk.trackPageLoad(); 请再三核对');
    }
    try {
      stReportSdk.push({
        accountId,
        eventId,
        eventDesc,
        eventBody
      });
    } catch (e) {
      // 为了能够继续往后走, 但是能够上报
      setTimeout(() => {
        throw e;
      });
    }
  };

  return { stReportSdk, getDiffRouteTime, report };
}
